import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import Field from "../Shared/Field";
import moment from "moment";

class CapacityAndCoachesPanel extends Component {
  render() {
    const { tcsAt, capacityStats } = this.props;

    return (
      <div id="capacity-coaches-wrapper">
        <Panel
          bsStyle="success"
          className="compact-panel"
          id="capacity-wrapper"
        >
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              {tcsAt
                ? `Capacity at ${moment(tcsAt).tz("Australia/Sydney").format("h:mm a")}`
                : "Capacity"}
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="d-flex justify-between">
              <div>Coaches</div>
              <strong>{capacityStats.available_coaches.length}</strong>
            </div>
            <div className="d-flex justify-between">
              <div>Deals</div>
              <strong>{capacityStats.deals_scheduled_at_same_time}</strong>
            </div>
            <div className="d-flex justify-between">
              <div>Confirmed Deals</div>
              <strong>
                {capacityStats.confirmed_deals_scheduled_at_same_time}
              </strong>
            </div>
          </Panel.Body>
        </Panel>
        <Panel bsStyle="success" className="compact-panel" id="coaches-wrapper">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Coaches</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="mb-2">
              {capacityStats.available_coaches.map((coach, index) => (
                <div key={index}>
                  {coach.first_name} {coach.last_name}
                </div>
              ))}
            </div>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

export default CapacityAndCoachesPanel;
